import { Link } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import AppSwitcher from "../components/AppSwitcher";
import "./Bokiori.css";

const GOOGLE_PLAY_URL =
  "https://play.google.com/store/apps/details?id=com.goldttak.bokiory_app";

const APPLE_STORE_BADGE =
  "https://static.wixstatic.com/media/c837a6_f118d3e42dd44391bb680dbf64fd9979~mv2.png/v1/fill/w_151,h_52,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Apple%20Store.png";
const GOOGLE_PLAY_BADGE =
  "https://static.wixstatic.com/media/c837a6_a8def159231d4dd6b5ca0c31ac29e2fc~mv2.png/v1/fill/w_171,h_52,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Google%20Play.png";
const APPLE_STORE_BADGE_CTA =
  "https://static.wixstatic.com/media/c837a6_f118d3e42dd44391bb680dbf64fd9979~mv2.png/v1/fill/w_120,h_40,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Apple%20Store.png";
const GOOGLE_PLAY_BADGE_CTA =
  "https://static.wixstatic.com/media/c837a6_a8def159231d4dd6b5ca0c31ac29e2fc~mv2.png/v1/fill/w_130,h_40,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Google%20Play.png";

const SHOWCASE_ITEMS = [
  {
    src: "/bokiori-assets/bokiori_home_1.png",
    title: "미션 수행 시간대비 업계 최대 보상",
    text: "미션을 하면 포인트를 얻을 수 있어요!",
  },
  {
    src: "/bokiori-assets/bokiori_home_2.png",
    title: "등급 업 보너스",
    text: "미션을 하면 등급이 자동 상승되고, 등급이 높아질수록 포인트가 눈덩이처럼 상승하는 시스템이에요",
  },
  {
    src: "/bokiori-assets/bokiori_home_3.png",
    title: "친구 포인트",
    text: "친구를 초대하여 친구에게 지속적으로 포인트를 받을 수 있어요!",
  },
  {
    src: "/bokiori-assets/bokiori_home_4.png",
    title: "1:1 기프티콘 교환",
    text: "얻은 포인트는 1대1 비율로 기프티콘과 교환할 수 있어요 (현금 인출 기능은 추후 출시 예정입니다)",
  },
  {
    src: "/bokiori-assets/bokiori_home_5.png",
    title: "특별응모권 클로버",
    text: '미션을 하면 특별응모권 "클로버"를 얻으실 수 있는데, 진행 중인 프로모션 상품에 응모할 수 있답니다.',
  },
];

function Bokiori() {
  const trackRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 768px)");
    const sync = () => setIsMobile(mq.matches);
    sync();
    mq.addEventListener("change", sync);
    return () => mq.removeEventListener("change", sync);
  }, []);

  const scrollToIndex = (index) => {
    const track = trackRef.current;
    if (!track) return;
    const slide = track.children[index];
    if (!slide) return;
    track.scrollTo({
      left: slide.offsetLeft - (track.clientWidth - slide.clientWidth) / 2,
      behavior: "smooth",
    });
    setActiveIndex(index);
  };

  const onTrackScroll = () => {
    if (!isMobile || !trackRef.current) return;
    const track = trackRef.current;
    const center = track.scrollLeft + track.clientWidth / 2;
    let nearest = 0;
    let nearestDist = Infinity;
    Array.from(track.children).forEach((child, i) => {
      const mid = child.offsetLeft + child.clientWidth / 2;
      const dist = Math.abs(mid - center);
      if (dist < nearestDist) {
        nearestDist = dist;
        nearest = i;
      }
    });
    setActiveIndex(nearest);
  };

  return (
    <div className="bokiori">
      <header className="bokiori-header">
        <div className="header-inner">
          <Link to="/bokiori" className="logo-link">
            <img
              src="/bokiori-assets/app-icon.png"
              alt="복이오리 앱 아이콘"
              className="header-logo"
            />
            <span className="header-title">복이오리 - 운세 앱테크</span>
          </Link>
          <div className="header-sns">
            <AppSwitcher />
          </div>
        </div>
      </header>

      <main className="bokiori-main">
        <section className="hero">
          <div className="hero-bg" />
          <div className="hero-content">
            <img
              src="/bokiori-assets/app-icon.png"
              alt="복이오리 로고"
              className="hero-logo"
            />
            <h1 className="hero-title">
              운세 앱테크
              <br /> <span>복이오리</span>
            </h1>
            <p className="hero-tagline">운세보고 돈도 번다</p>
            <div className="hero-buttons">
              <span
                className="store-btn store-btn-disabled"
                title="App Store 출시 예정"
              >
                <img src={APPLE_STORE_BADGE} alt="App Store 출시 예정" />
              </span>
              <a
                href={GOOGLE_PLAY_URL}
                target="_blank"
                rel="noreferrer noopener"
                className="store-btn"
              >
                <img src={GOOGLE_PLAY_BADGE} alt="Google Play에서 다운로드" />
              </a>
            </div>
          </div>
        </section>

        <section className="showcase">
          <div className="showcase-header">
            <p className="showcase-eyebrow">앱 미리보기</p>
            <h2 className="section-title">복이오리로 쌓는 혜택</h2>
            <p className="section-subtitle">
              미션 · 등급 · 친구 · 기프티콘 · 클로버까지
            </p>
          </div>

          <div
            className="showcase-track"
            ref={trackRef}
            onScroll={onTrackScroll}
            aria-label="복이오리 앱 소개"
          >
            {SHOWCASE_ITEMS.map((item, index) => (
              <article
                key={item.src}
                className={`showcase-card ${
                  index % 2 === 1 ? "showcase-card-reverse" : ""
                }`}
              >
                <div className="showcase-media">
                  <img src={item.src} alt={item.title} loading="lazy" />
                </div>
                <div className="showcase-copy">
                  <span className="showcase-index">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  <h3 className="showcase-card-title">{item.title}</h3>
                  <p className="showcase-card-text">{item.text}</p>
                </div>
              </article>
            ))}
          </div>

          <div className="showcase-dots" aria-hidden={!isMobile}>
            {SHOWCASE_ITEMS.map((item, index) => (
              <button
                key={item.src}
                type="button"
                className={`showcase-dot ${
                  index === activeIndex ? "active" : ""
                }`}
                aria-label={`${index + 1}번째 소개`}
                onClick={() => scrollToIndex(index)}
              />
            ))}
          </div>
        </section>

        <section className="cta">
          <div className="cta-inner">
            <img
              src="/bokiori-assets/duck-gift.jpg"
              alt="복이오리 캐릭터"
              className="cta-duck"
            />
            <div className="cta-content">
              <p className="cta-subtitle">수행시간 대비 최대 보상 앱테크</p>
              <h2 className="cta-title">
                복이오리를
                <br />
                지금 바로 만나보세요
              </h2>
              <div className="cta-buttons">
                <span
                  className="store-btn store-btn-disabled"
                  title="App Store 출시 예정"
                >
                  <img src={APPLE_STORE_BADGE_CTA} alt="App Store 출시 예정" />
                </span>
                <a
                  href={GOOGLE_PLAY_URL}
                  target="_blank"
                  rel="noreferrer noopener"
                  className="store-btn"
                >
                  <img src={GOOGLE_PLAY_BADGE_CTA} alt="Google Play" />
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>

      <footer className="bokiori-footer">
        <div className="footer-inner">
          <img
            src="/bokiori-assets/app-icon.png"
            alt="복이오리"
            className="footer-logo"
          />
          <p className="footer-company">주식회사 셀링</p>
          <p className="footer-address">
            화성시 동탄대로21길 10 1512-에이18호(더피스트타워)
            <br />
            215-88-01706 | 대표 이지훈
          </p>
          <p className="footer-tel">031-221-9719</p>
        </div>
        <p className="footer-copy">
          © 2024 주식회사 셀링. All rights reserved.
        </p>
      </footer>
    </div>
  );
}

export default Bokiori;
